import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { EmployeeDetails } from "../../env/action";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import company2 from "../../assets/company2.png";
import company3 from "../../assets/company3.png";
import company4 from "../../assets/company4.png";
import company5 from "../../assets/Screenshot_1.png";
import company6 from "../../assets/company6.png";

const leadersData = [
  {
    name: "Jan Ingenhousz",
    image: company2,
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
  },
  {
    name: "Jan Ingenhousz",
    image: company3,
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
  },
  {
    name: "Jan Ingenhousz",
    image: company4,
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
  },
  {
    name: "Jan Ingenhousz",
    image: company5,
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
  },
  {
    name: "Jan Ingenhousz",
    image: company6,
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
  },
];

const OurLeadership = () => {
  const [employeeDetails, setEmployeeDetails] = useState([]);
  useEffect(() => {
    EmployeeDetails(((res) => {
      if (res.status === 1) {
        setEmployeeDetails(res.data);

      } else {
        console.log('No employee details found');
      }
    }))
  }, [])

  const staffSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <Container>
      <div>
        <p className="fs-3 fw-bolder">Our Leadership</p>
      </div>
      <Slider {...staffSliderSettings}>
        {employeeDetails.map((employee, index) => (
          <div key={index} className="px-2">
            <Card className="h-100 text-center shadow-sm border-0 rounded-3">
              <Card.Img
                variant="top"
                src={employee.employee_profileimage}
                style={{
                  height: "180px",
                  objectFit: "contain",
                }}
              />
              <Card.Body className="p-3">
                <Card.Title className="fs-6 fw-bold text-uppercase">
                  {employee.employee_name}
                </Card.Title>
                <Card.Text style={{ fontSize: "13px", color: "#878787" }}>{employee.department} • {employee.experience_or_fresher}</Card.Text>
              </Card.Body>
            </Card>
          </div>
        ))}
      </Slider>

    </Container>
  );
};

export default OurLeadership;
